module.exports = __webpack_public_path__ + "static/media/type-advantages.e18dc051.png";